import enCommon from './en/common.json'
import plCommon from './pl/common.json'
import ukCommon from './uk/common.json'

export default {
  en: {
    common: enCommon,
  },
  pl: {
    common: plCommon,
  },
  uk: {
    common: ukCommon,
  },
}
